import React from 'react'

// ──────────────────────────────────────────────────────────────────────────
// Etiqueta label/valor de solo lectura, usada en el recordatorio de arriba de
// los pasos 3 (Declaraciones), 4 (Feedback) y, más adelante, 5 (Resumen) del
// wizard de convocatoria Masiva. Extraída de DeclaracionesStep.jsx para no
// duplicarla en cada paso — ver esa nota (26/08/2026) sobre por qué esto va
// como etiqueta simple y no como InputText/InputSelect deshabilitado.
// ──────────────────────────────────────────────────────────────────────────
const RecapField = ({ label, value }) => (
    <div style={{ minWidth: "150px" }}>
        <div className="modal-label" style={{ marginBottom: "2px" }}>{label}</div>
        <div className="black-color font-weight-bold">{value ?? "-"}</div>
    </div>
)

export default RecapField
